import { resolveApiBaseUrl } from './resolveApiBaseUrl';

const BACKEND_URL = resolveApiBaseUrl(process.env.REACT_APP_POS2U_API_URL);

export const POST_LOGIN = BACKEND_URL + '/auth/user/token';
export const GET_MY_ACCOUNT = BACKEND_URL + '/auth/user/me';
export const PUT_REFRESH_TOKEN = BACKEND_URL + '/auth/token';
export const POST_LOGOUT = BACKEND_URL + '/auth/logout';
export const GET_CHECK_LOGIN = BACKEND_URL + '/auth/check/login';

export const POST_ADD_PRODUCT = BACKEND_URL + '/products/save';
export const POST_UPDATE_PRODUCT = BACKEND_URL + '/products/save/';

export const POST_ADD_IMAGE = BACKEND_URL + '/products/upload/image';
export const PUT_EDIT_PRODUCT = BACKEND_URL + '/products/save/';
export const GET_PRODUCTS = BACKEND_URL + '/products';
export const GET_PRODUCTS_V2 = BACKEND_URL + '/products/v2';
export const GET_PRODUCTS_V3 = BACKEND_URL + '/products/v3';
export const GET_PRODUCTS_BY_ID = BACKEND_URL + '/products/';
export const DELETE_BULK_PRODUCT = BACKEND_URL + '/products/bulk-delete';
// export const GET_SEARCH_PRODUCT = BACKEND_URL + '/es/products';
export const GET_SEARCH_PRODUCT = BACKEND_URL + '/es/products/search';
export const POST_SEARCH_PRODUCT_IDS = BACKEND_URL + '/es/products/search/ids';
export const GET_SEARCH_PRODUCT_PAGINATION_IDS =
  BACKEND_URL + '/es/products/search/pagination/ids';
export const POST_PRODUCTS_SIMPLE = BACKEND_URL + '/products/simple';

export const GET_PRODUCT_PRICES_BY_ID = BACKEND_URL + '/products/prices/';
export const PUT_UPDATE_PRICE = BACKEND_URL + '/products/prices/save';

export const GET_CHECK_COMPOSITE = BACKEND_URL + '/products/check-composite/';

export const GET_EXPORT_PRODUCTS_INFORMATION =
  BACKEND_URL + '/products/export/information';
export const GET_EXPORT_GROUPED_PRODUCTS_INFO =
  BACKEND_URL + '/products/export/information/group';

export const GET_EXPORT_PRODUCTS_QUANTITY =
  BACKEND_URL + '/products/export/quantity';

export const GET_INVENTORY_HISTORY = BACKEND_URL + '/product-inventory/history';
export const PUT_UPDATE_INVENTORY = BACKEND_URL + '/product-inventory/save/';

export const GET_PRODUCT_OPTION_BY_ID = BACKEND_URL + '/product-option/';
export const GET_PRODUCT_OPTION_LIST = BACKEND_URL + '/product-option';
export const GET_CHECK_TOTAL_PRODUCT_OPTIONS =
  BACKEND_URL + '/product-option/check-total';
export const POST_ADD_PRODUCT_OPTION = BACKEND_URL + '/product-option/save';
export const POST_CHECK_PRODUCT_OPTION_EXISTS =
  BACKEND_URL + '/product-option/check-name-exists';
export const PUT_UPDATE_PRODUCT_OPTION = BACKEND_URL + '/product-option/save';
export const PUT_PRODUCT_OPTION_SORT_ORDER =
  BACKEND_URL + '/product-option/sort-order';
export const PATCH_PARTIAL_UPDATE_PRODUCT_OPTION =
  BACKEND_URL + '/product-option/save';
export const DELETE_PRODUCT_OPTION_BY_ID = BACKEND_URL + '/product-option/';

export const GET_CATEGORIES = BACKEND_URL + '/categories';
export const POST_ADD_CATEGORY = BACKEND_URL + '/categories/save';
export const PUT_UPDATE_CATEGORY = BACKEND_URL + '/categories/save';
export const DELETE_BULK_CATEGORY = BACKEND_URL + '/categories/bulk-delete';

export const GET_SUPPLIERS = BACKEND_URL + '/suppliers';

export const GET_MERCHANT_ME = BACKEND_URL + '/merchants/me';
export const GET_STORES_ME = BACKEND_URL + '/stores';

export const POST_ADD_PROMOTION = BACKEND_URL + '/promotions/save';
export const PUT_UPDATE_PROMOTION = BACKEND_URL + '/promotions/save/';
export const DELETE_PROMOTIONS_BATCH = BACKEND_URL + '/promotions/batch';

export const GET_ALL_PROMOTIONS = BACKEND_URL + '/promotions/all';
export const GET_PROMOTION_BY_ID = BACKEND_URL + '/promotions/';
export const GET_PROMOTION_LIST = BACKEND_URL + '/promotions';

export const GET_TAGS = BACKEND_URL + '/tags';
export const POST_ADD_TAG = BACKEND_URL + '/tags/save';
export const PUT_UPDATE_TAG = BACKEND_URL + '/tags/save/';
export const DELETE_TAG = BACKEND_URL + '/tags/delete/';
export const DELETE_BULK_TAG = BACKEND_URL + '/tags/bulk-delete';

export const GET_CUSTOMERS = BACKEND_URL + '/customers';
export const GET_SEARCH_CUSTOMERS = BACKEND_URL + '/es/customers/search';
export const POST_SEARCH_CUSTOMER_IDS =
  BACKEND_URL + '/es/customers/search/ids';
export const GET_SEARCH_CUSTOMERS_PAGINATION_IDS =
  BACKEND_URL + '/es/customers/search/pagination/ids';
export const POST_CUSTOMERS_SIMPLE = BACKEND_URL + '/customers/simple';
export const GET_EXPORT_CUSTOMERS = BACKEND_URL + '/customers/export';
export const GET_CUSTOMER_BY_ID = BACKEND_URL + '/customers/';
export const POST_ADD_CUSTOMERS = BACKEND_URL + '/customers';
export const PUT_UPDATE_CUSTOMERS = BACKEND_URL + '/customers/';
export const DELETE_BULK_CUSTOMERS = BACKEND_URL + '/customers/bulk-delete';
export const GET_CUSTOMER_POINTS_BY_ID = BACKEND_URL + '/customers/points/';
export const PUT_ADJUST_CUSTOMER_POINTS =
  BACKEND_URL + '/customers/adjust_point/';
export const GET_CUSTOMER_POINTS_HISTORY_BY_ID =
  BACKEND_URL + '/customers/points_history/';
export const GET_TIME_ATTENDANCE = BACKEND_URL + '/time-attendance';
export const GET_WORKING_TIME_BY_ID = BACKEND_URL + '/time-attendance';
export const PUT_UPDATE_WORKING_TIME = BACKEND_URL + '/time-attendance';
export const GET_TIME_ATTENDANCE_EXPORT_DAILY =
  BACKEND_URL + '/time-attendance/export/daily';
export const GET_TIME_ATTENDANCE_EXPORT_MONTHLY =
  BACKEND_URL + '/time-attendance/export/monthly';

export const GET_PROVINCES = BACKEND_URL + '/locations/provinces/shipping';
export const GET_DISTRICTS = BACKEND_URL + '/locations/districts/shipping';
export const GET_SUBDISTRICTS =
  BACKEND_URL + '/locations/subdistricts/shipping';

// ===== Store settings (/settings/general) =====
export const GET_SETTINGS = BACKEND_URL + '/settings/general';
export const GET_SETTINGS_ACCESS = BACKEND_URL + '/settings/general/access';
export const POST_SETTINGS_LOGO = BACKEND_URL + '/settings/general/logo';
export const PUT_SETTINGS_PRICE = BACKEND_URL + '/settings/general/price';
export const PUT_SETTINGS_BARCODE = BACKEND_URL + '/settings/general/barcode';
export const PUT_SETTINGS_WEIGHT_BARCODE =
  BACKEND_URL + '/settings/general/weight-barcode';
export const PUT_SETTINGS_DOCUMENT = BACKEND_URL + '/settings/general/document';
export const PUT_SETTINGS_ROUNDING = BACKEND_URL + '/settings/general/rounding';
export const PUT_SETTINGS_POINTS = BACKEND_URL + '/settings/general/points';
export const PUT_SETTINGS_SERVICE_CHARGE =
  BACKEND_URL + '/settings/general/service-charge';
export const PUT_SETTINGS_INVOICE_CODE =
  BACKEND_URL + '/settings/general/invoice-code';

// service connections / payment credentials
export const GET_SERVICE_CONNECTIONS = BACKEND_URL + '/settings/connections';
export const GET_SERVICE_CONNECTION_DUPLICATE =
  BACKEND_URL + '/settings/connections/check-duplicate';
export const GET_SERVICE_CONNECTION_BANKS =
  BACKEND_URL + '/settings/connections/banks';
export const POST_SERVICE_CONNECTION = BACKEND_URL + '/settings/connections';
export const PUT_SERVICE_CONNECTION_STATUS = (id: number) =>
  BACKEND_URL + `/settings/connections/${id}/status`;
export const DELETE_SERVICE_CONNECTION = (id: number) =>
  BACKEND_URL + `/settings/connections/${id}`;

export const GET_TISI_PROVINCES = BACKEND_URL + '/locations/provinces';
export const GET_TISI_DISTRICTS = BACKEND_URL + '/locations/districts';
export const GET_TISI_SUBDISTRICTS = BACKEND_URL + '/locations/subdistricts';

// export const POST_JWT_LOGIN = BACKEND_URL + "/post-jwt-login";
// export const POST_PASSWORD_FORGET = BACKEND_URL + "/auth/forgot-password";
// export const POST_JWT_PASSWORD_FORGET = BACKEND_URL + "/jwt-forget-pwd";
